export const mapToOptions = (items = [], defaultOption) => {
  const mapped = items.map(({ id, name }) => ({ label: name, value: id }));

  return defaultOption ? [defaultOption, ...mapped] : mapped;
};
